import ReactGA from 'react-ga4'
import config from '../config'

const CATEGORY_FUND = 'fund'
const CATEGORY_FAMILY= 'family'
const CATEGORY_MORNINGSTAR = 'mstar'
const CATEGORY_FFF = 'gff'
const CATEGORY_WFF = 'gff'
const CATEGORY_TOOLKIT= 'toolkit'
const CATEGORY_STAFF_SUPPORT = 'staff'

function event(eventProps){
  // console.log('event:',eventProps)
  if( config.gaKey ){
    ReactGA.event( eventProps)
  }
}

function eventToMorningstar(investmentVehicleId){
  return {
    category: CATEGORY_MORNINGSTAR,
    action: 'fund_to_morningstar',
    label: 'investmentVehicleId:'+investmentVehicleId,
  }
}

function eventToFamily(familyName){
  return {
    category: CATEGORY_FAMILY,
    action: 'front_to_family',
    label: 'family:'+familyName,
  }
}

function eventLoadFund(fundId, investmentVehicleId){
  return {
    category: CATEGORY_FUND,
    action: 'fund_searched',
    label: 'fundId:'+fundId+',investmentId:'+ investmentVehicleId,
  }
}

function eventToFamilyPopup(familyName){
  return {
    category: CATEGORY_FAMILY,
    action: 'popup_to_family',
    label: 'family:'+familyName,
  }
}

function eventToFamilyTakeAction(familyName){
  return {
    category: CATEGORY_FAMILY,
    action: 'family_take_action',
    label: 'family:'+familyName,
  }
}

function eventToFFF(fundId,investmentVehicleId){
  return {
    category: CATEGORY_FFF,
    action: 'to_fff',
    label: 'fundId:'+fundId+',investmentId:'+ investmentVehicleId,
  }
}

function eventToWFF(fundId,investmentVehicleId){
  return {
    category: CATEGORY_WFF,
    action: 'to_wff',
    label: 'fundId:'+fundId+',investmentId:'+ investmentVehicleId,
  }
}

function eventToToolkit(){
  return {
    category: CATEGORY_TOOLKIT,
    action: 'to_toolkit',
  }
}

function eventStaffSupport(companyName, action){
  return {
    category: CATEGORY_STAFF_SUPPORT,
    action: 'staff_support',
    label: companyName + ' ' + action
  }
}

export default {
  event,
  eventToMorningstar,
  eventToFamily,
  eventToFamilyPopup,
  eventLoadFund,
  eventToFamilyTakeAction,
  eventToFFF,
  eventToWFF,
  eventToToolkit,
  eventStaffSupport
}
